<p-toast></p-toast>
<div class="continer-card">
    <div class="card card-botonera">
        <div class="row justify-content-end">
            <button pButton class="bc-primary " label="Nueva Persona" icon="pi pi-user-plus" (click)="openDialog()">
            </button>
            <div class="pr-3">
                <!-- <p-autoComplete (onClear)="allPersons()" [delay]="2000" placeholder="Buscar persona"
                    (completeMethod)="onSearchChangeAu($event)" [type]="'search'">
                </p-autoComplete> -->
            </div>
        </div>
    </div>
    <p-table #dt [value]="users" styleClass="p-datatable-striped p-datatable-sm p-datatable-gridlines">
        <ng-template pTemplate="header" pTemplate="header">
            <tr>
                <th scope="col" [ngStyle]="{'width': '14%','text-align':'center'}">Usuario </th>
                <th scope="col" [ngStyle]="{'width': '24%','text-align':'center'}">Nombre</th>
                <th scope="col" [ngStyle]="{'width': '24%','text-align':'center'}">Correo </th>
                <!-- <th scope="col" [ngStyle]="{'width': '8%'}" class="text-center">Documento </th>
                        <th scope="col" [ngStyle]="{'width': '10%'}">Identificación </th> -->
                <!--  <th scope="col" [ngStyle]="{'width': '23%'}" class="text-center">Punto de Venta </th> -->
                <th scope="col" [ngStyle]="{'width': '15%'}" class="text-center">Acción</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" pTemplate="body" let-user>
            <tr>
                <td class="elli">{{user.userName}}</td>
                <td>{{user.person.fullName}}</td>
                <td class="elli">{{user.person.email}}
                </td>
                <!-- <td class="elli">{{user.establishment?.name}}</td> -->
                <td style="text-align: center;">
                    <i class="material-icons color-icon-primary" type="button"
                        pTooltip="Editar {{user.userName}}" tooltipPosition="left"
                        (click)="editGenerateUserComponent(user)">drive_file_rename_outline
                    </i>
                </td>
            </tr>
        </ng-template>
        <!--  <ng-template pTemplate="summary">
            <div class="p-d-flex p-ai-center p-jc-between">
                Existen {{totalElements ? totalElements : 0 }} usuarios {{activeUser ?'Activos':'Inactivos'}}
            </div>
        </ng-template> -->
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="5">No se ha encontrado registros.</td>
            </tr>
        </ng-template>
    </p-table>
    <!-- <h2 class="center m-4 text-warning" *ngIf="totalElements==0">No hay resultados de su busqueda</h2>
    <p-paginator #paginator [rows]="size" [totalRecords]="totalElements" (onPageChange)="paginate($event)">
    </p-paginator> -->
    <div class="row p-justify-center">
        <span class="p-paginator-current ng-star-inserted">Registros {{ pageSince }} de {{ pageUntil }} del total
            {{ totalElements }}</span>
        <p-paginator #paginator [rows]="size" [totalRecords]="totalElements" (onPageChange)="paginate($event)">
        </p-paginator>
        <p-dropdown class="pt-3 dp-paginate" [options]="elements" [(ngModel)]="size" [showClear]="false"></p-dropdown>
    </div>
    <p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
</div>

<p-dialog  [header]="mode === 'CREATE' ? 'Crear Usuario' : 'Editar Usuario'" [(visible)]="displayDialog" [modal]="true" [style]="{ width: '600px' }"
    [closable]="true" (onHide)="resetForm()">

    <form [formGroup]="personForm" class="p-fluid" (ngSubmit)="save()">


        <div class="row pl-3 pr-3">
            <div class="field half">
                <label for="firstName">Nombres</label>
                <input pInputText class="uppercase" style="height: 35px;" id="firstName" formControlName="firstName" />
            </div>
            <div class="field half">
                <label for="lastName">Apellidos</label>
                <input pInputText class="uppercase" style="height: 35px;" id="lastName" formControlName="lastName" />
            </div>
        </div>

        <div class="row pl-3 pr-3 pt-3">
            <div class="field">
                <label for="identificationType">Tipo Identificación</label>
                <p-dropdown id="identificationType" [options]="identificationTypes" optionLabel="label"
                    optionValue="value" formControlName="identificationType">
                </p-dropdown>
            </div>
            <!-- DNI -->
            <div class="field half">
                <label for="dni">Documento</label>
                <input pInputText style="height: 35px;" id="dni" formControlName="dni" />
            </div>
            <!-- Usuario -->
            <div class="field half">
                <label for="userName">Usuario</label>
                <input pInputText style="height: 35px;" id="userName" formControlName="userName" />
            </div>
        </div>
        <!-- Bodega -->
        <div class="field pt-3">
            <label for="warehouse">Bodega</label>
            <p-dropdown formControlName="warehouse" [options]="warehouses" optionLabel="name"
                placeholder="Seleccione Bodega"></p-dropdown>
            <!-- <input pInputText style="height: 35px;" id="warehouse" formControlName="warehouse" /> -->
        </div>
        <!-- Email -->
        <div class="field pt-3">
            <label for="email">Email</label>
            <input pInputText style="height: 35px;" id="email" formControlName="email" />
        </div>

        <!-- Teléfono + PIN -->
        <div class="row pl-3 pr-3 pt-3">
            <div class="field half">
                <label for="phone">Teléfono</label>
                <input pInputText style="height: 35px;" id="phone" formControlName="phone" />
            </div>
            <!-- <div class="field half">
                <label for="pin">PIN</label>
                <input pInputText style="height: 35px;" id="pin" formControlName="pin" maxlength="4" />
            </div> -->
            <div class="flex pt-3">
                <p-checkbox binary="true" formControlName="active" inputId="active">
                </p-checkbox>
                <label for="active" class="ml-2 mt-2">Activo</label>
            </div>
        </div>

        <!-- Botones -->
        <div class="row pl-3 pr-3 pt-4">
            <div class="field half">
                <button pButton label="Cancelar" class="border-secondary" (click)="displayDialog = false">
                </button>
            </div>
            <div class="field half">
                <button pButton  [label]="mode === 'CREATE' ? 'Guardar' : 'Actualizar'" type="submit" class="border-primary" [disabled]="personForm.invalid">
                </button>
            </div>
        </div>

    </form>
</p-dialog>